import Types from "./types";

export default (message) => ({
	type: Types.NOTIFICATIONS_ERROR_CHANGED,
	payload: message,
});
